import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

export default function LoaderHavePopup({ loading = false, popupText }) {
    return (
        <div>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {loading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: '40%',
                        left: '50%',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '8px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                        zIndex: 1300, // Số nguyên thay vì function,
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                        {popupText}
                    </Typography>
                </Box>
            )}
        </div>
    );
}
